import React from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { hideMessageModal } from "../../redux/messageModalSlice";
import { useNavigate } from "react-router-dom";

const MessageModal: React.FC = () => {
	const dispatch = useDispatch();
	const nav = useNavigate();
	const { isVisible, title, message, userId } = useSelector(
		(state: RootState) => state.messageModal
	);

	const handleCancel = () => {
		dispatch(hideMessageModal());
	};
	const handleOk = () => {
		dispatch(hideMessageModal());
		nav("/messages", {
			state: { userId: userId || null },
		});
	};

	return (
		<Modal
			title={title}
			open={isVisible}
			onCancel={handleCancel}
			onOk={handleOk}
			okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			okText={"Në rregull"}
			cancelText={"Mbyll"}
		>
			{message && (
				<div
					style={{ whiteSpace: "pre-line" }}
					dangerouslySetInnerHTML={{
						__html: message,
					}}
				/>
			)}
		</Modal>
	);
};

export default MessageModal;
